import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-button-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                [ngStyle]="{ width: column.width || 'auto' }"
                [ngClass]="[
                    alignRight ? classNames.AlignRight : '',
                    column.truncateTextCss ? classNames.TextTruncate : '',
                    column.wrapText ? classNames.TextWrapTableCell : '',
                    'not-sortable',
                    !!column.headerPopoverContent ? classNames.ThWithPopover : '',
                    column.className || ''
                ]"
            >
                <!-- Custom Column Header -->
                <div *ngFor="let customHeader of customColumnHeaders">
                    <ng-container
                        *ngTemplateOutlet="customHeader.templateRef; context: { row: row }"
                    ></ng-container>
                </div>

                <!-- Default Column Header -->
                <ng-container *ngIf="!customColumnHeaders.length">
                    <div class="th-content">
                        <ng-container *ngIf="column.headerPopoverContent">
                            <popover-content
                                #headerPopover
                                [size]="column.headerPopoverSize || 'small'"
                            >
                                {{ column.headerPopoverContent }}
                            </popover-content>
                            <div
                                [popover]="headerPopover"
                                [popoverPlacement]="getHeaderPopoverPlacement()"
                            >
                                <span [innerHtml]="column.header"></span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!column.headerPopoverContent">
                            <span [innerHtml]="column.header"></span>
                        </ng-container>
                    </div>
                </ng-container>
            </th>
            <td
                cdk-cell
                *cdkCellDef="let row"
                class="button-cell"
                [ngClass]="classNames.TextCenter"
                [style.width]="column.width"
            >
                <div class="table-button-container">
                    <lsq-button
                        *ngIf="!hideButton || !hideButton(row)"
                        [disabled]="!!disableButton && disableButton(row)"
                        [appearance]="'transparent'"
                        (buttonClick)="buttonClick.emit(row)"
                    >
                        <lsq-icon [type]="icon" [color]="color.Green"></lsq-icon>
                    </lsq-button>
                </div>
            </td>
        </ng-container>
    `,
    styleUrls: ['./button-column.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqButtonColumnComponent extends LsqBaseColumnComponent {
    @Output() public buttonClick: EventEmitter<any> = new EventEmitter();
    @Input() public hideButton: (row: any) => boolean;
    @Input() public disableButton: (row: any) => boolean;
    @Input() public icon: Icons;
    public color = Color;
}
